import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ChallengeUser} from "../../models/challenge-user";
import {ChallengeProvider} from "../../providers/challenge/challenge";
import {
  AppChallengeUserPopupAchievedPage
} from "../app-challenge-user-popup-achieved/app-challenge-user-popup-achieved";

/**
 * Generated class for the AppChallengeUserPopupCompletionRequestPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-challenge-user-popup-completion-request',
  templateUrl: 'app-challenge-user-popup-completion-request.html',
})
export class AppChallengeUserPopupCompletionRequestPage {

  challenge: ChallengeUser;
  previewMode: boolean;
  constructor(public navCtrl: NavController, public navParams: NavParams, private challengeProvider: ChallengeProvider) {
    this.challenge = this.navParams.get('challenge');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppChallengeUserPopupCompletionRequestPage');
  }

  challengeTryAgain() {
    this.challengeProvider.userChallengeUpdate(this.challenge, {status: 1}).then(() => {
      this.navCtrl.pop();
    })
  }
  challengeFinished() {
    this.challengeProvider.userChallengeUpdate(this.challenge, {status: 2}).then(() => {
      this.navCtrl.pop().then(() => {
        this.navCtrl.push(AppChallengeUserPopupAchievedPage, {challenge: this.challenge});
      })
    })
  }
  challengeSkip() {
    this.challengeProvider.userChallengeUpdate(this.challenge, {status: -1}).then(() => {
      this.navCtrl.pop();
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user-popup-completion-request/app-challenge-user-popup-completion-request.ts